import { getContractNumberLabel } from './getContractNumberLabel';

/**
 * Returns "<contract number> - <contract name>" for naming a contract in prose
 * and select options. The number falls back to the "no contract number"
 * placeholder; the name is left out when empty.
 */
export function getContractDisplayLabel(
  buyerAssignedId: string | null | undefined,
  contractName: string | null | undefined,
) {
  return [getContractNumberLabel(buyerAssignedId), contractName?.trim()]
    .filter(Boolean)
    .join(' - ');
}
